import { gql } from 'graphql-request';

// Fragments are a way to share field definitions between GraphQL queries. To create one, you can add a new `shape` that defines `fields` on a specific GQL node.
// To use it in a query, you must add the fragment definition at the top (`${myNewShape}`) of the query, then spread the fields within the query (`...myNewFields`).
// You can also use fragments within fragments, as you can see in the `audiobookWithShoppingCartAndUserAudiobookShape` example below.

const productShape = gql`
  fragment productFields on Product {
    discountPrice
    id
    isFreeListing
    listingPrice
    purchaseUrl
    savingsPercent
    showListingPrice
    timeLeft
    bannerType
    featuredNewRelease
    hotDeal
  }
`;

// NOTE: This is a core fragment used almost everywhere in Chirp!
// Please be mindful of the performance/impact (such as N+1 queries) of any fields added here.
// Alternately, you may be able to add your field to one of the other fragments or just your query.
const audiobookShape = gql`
  fragment audiobookFields on Audiobook {
    id
    averageRating
    coverUrl
    displayAuthors
    displayTitle
    ratingsCount
    url
    allAuthors {
      name
      slug
      url
    }
  }
`;


const audiobookUserAudiobookPlayableShape = gql`
  fragment audiobookUserAudiobookPlayableFields on Audiobook {
    currentUserUserAudiobook {
      archived
      playable
      playerUrl
    }
  }
`;

const audiobookWithShoppingCartAndUserAudiobookShape = gql`
  ${audiobookShape}
  fragment audiobookWithShoppingCartAndUserAudiobookFields on Audiobook {
    ...audiobookFields
    currentUserShoppingCartItem {
      id
    }
    currentUserWishlistItem {
      id
    }
    currentUserUserAudiobook {
      id
    }
  }
`;

const checkoutSummaryShape = gql`
  fragment checkoutSummaryFields on CheckoutSummary {
    discountSubtotal
    discountTotal
    originalTotal
    subtotal
    giftCardAppliedTotal
    grandTotal
    grandTotalAfterGiftCards
    promoCodeDiscount
    salesTax
    promoCode {
      id
      name
    }
  }
`;

const promotionShape = gql`
  ${audiobookWithShoppingCartAndUserAudiobookShape}
  ${productShape}

  fragment promotionFields on Promotion {
    id
    audiobook {
      ...audiobookWithShoppingCartAndUserAudiobookFields
    }
    product {
      ...productFields
    }
  }
`;

const shoppingCartItemShape = gql`
  ${audiobookShape}
  fragment shoppingCartItemFields on ShoppingCartItem {
    audiobook {
      ...audiobookFields
      bookDescription
      bookDescriptionShort
      editorialDescription
      deletedForCurrentUser
      matchesCurrentUserExistingTitle
      priceWhenAddedToCurrentUserCart
      currentProduct {
        discountPrice
        discountedPriceCents
        id
        isFreeListing
        listingPrice
        showListingPrice
        timeLeft
      }
    }
  }
`;

export const graphQLFragments = {
  audiobookShape,
  audiobookUserAudiobookPlayableShape,
  audiobookWithShoppingCartAndUserAudiobookShape,
  checkoutSummaryShape,
  productShape,
  promotionShape,
  shoppingCartItemShape,
};
